import { gql } from "lib/apolloClient";
import {
  academicYearFragment,
  curriculumProgramFragment,
  resolvedFieldValueFragment,
} from "modules/CommonFragments";

export const unitPlanFeedFragment = {
  unitPlanFeed: gql`
    fragment unitPlanItem on UnitPlan {
      id
      state
      startDate
      endDate
      isImported
      createdBy {
        id
        firstName
        middleName
        type
        lastName
        profileImage
      }
      curriculumProgram {
        ...curriculumProgramBasicDetailsItem
      }
      owner {
        id
        firstName
        middleName
        type
        lastName
        profileImage
      }
      title {
        id
        value
      }
      unitCode {
        id
        value
      }
      grades
      resolvedGrades {
        id
        name
      }
      duration {
        id
        value
      }
      unitType {
        id
        value
      }
      image {
        id
        value
        resolvedMinimalTree {
          ...resolvedFieldVideoAttachmentItem
        }
      }
      templateId
      subjects {
        id
        value
        resolvedMinimalTree {
          ... on ResolvedFieldSubjectSet {
            id
            subjects {
              id
              name
              __typename
            }
            __typename
          }
          __typename
        }
      }
      resourceLibrary {
        leCount
        assessmentCount
      }
      assessmentTemplate
      leTemplate
      academicYears {
        ...academicYearItem
      }
      submittedToCommunity
      fields(uids: ["hours", "subjectLevel", "objectiveLevel"]) {
        id
        uid
        value
        resolvedMinimalTree {
          ...resolvedMinimalTreeItem
        }
      }
      createdAt
      updatedAt
      centralRepoConfig(input: $centralRepoInput) {
        newVersionId
        isSeen
        derivedStatus
        publishedDate
      }
      cascadeUpdatedBy {
        id
        firstName
        lastName
        profileImage
      }
      cascadeUpdateAt
    }
    ${academicYearFragment.academicYear}
    ${curriculumProgramFragment.curriculumProgramBasicDetails}
    ${resolvedFieldValueFragment.resolvedMinimalTree}
    ${resolvedFieldValueFragment.resolvedFieldVideoAttachment}
  `,
};

export const organizationUnitPlanFeedFragment = {
  organizationUnitPlanFeedV2: gql`
    fragment organizationUnitPlanFeedItem on Organization {
      id
      unitPlans: unitPlansV2(first: 20, after: $after, filters: $filters) {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            ...unitPlanItem
          }
        }
      }
    }
    ${unitPlanFeedFragment.unitPlanFeed}
  `,
};
